var moneyFormat = shop_money_format;
//Currency variable is coming from - https://cdn.shopify.com/s/javascripts/currencies.js
$currency_rate = 1;
if(Currency!=undefined && Currency.rates!=undefined && Currency.rates[shop_currency]!=undefined){
    if(shop_currency=='USD'){
        $currency_rate = 1;
    }else{
        $currency_rate = Currency.rates[shop_currency];
    }
}

$market_currency_rate = 1;
if(Currency!=undefined && Currency.rates!=undefined && Currency.rates[market_currency]!=undefined){
    if(market_currency=='USD'){
        $market_currency_rate = 1;
    }else{
        $market_currency_rate = Currency.rates[market_currency];
    }
}

function price_in_shop_currency(vdb_doller_price){
    var price_in_shop_currency = vdb_doller_price/$currency_rate;
    return price_in_shop_currency;
}
function price_in_market_currency(vdb_doller_price){
    var price_in_market_currency = vdb_doller_price/$market_currency_rate;
    return price_in_market_currency;
}
function currency_conversion(price,from_currency,to_currency){
    //Currency variable and convert function is coming from - https://cdn.shopify.com/s/javascripts/currencies.js
    let converted_price = price;
    if(Currency!=undefined && Currency.convert!=undefined){
        converted_price = Currency.convert(price,from_currency,to_currency);
    }
    return converted_price;
}
function formatMoney(cents, format) {
    if (typeof cents === 'string') {
        cents = cents.replace('.', '');
    }
    var value = '';
    var formatString = format || moneyFormat;

    function formatWithDelimiters(number, precision, thousands, decimal) {
        thousands = thousands || ',';
        decimal = decimal || '.';

        if (isNaN(number) || number === null) {
            return 0;
        }

        number = (number / 100.0).toFixed(precision);

        var parts = number.split('.');
        var dollarsAmount = parts[0].replace(
            /(\d)(?=(\d\d\d)+(?!\d))/g,
            '$1' + thousands
        );
        var centsAmount = parts[1] ? decimal + parts[1] : '';

        return dollarsAmount + centsAmount;
    }

    if(formatString.includes('{{amount}}')){
        value = formatWithDelimiters(cents, 2);
        return formatString.replace('{{amount}}', value);
    }else if(formatString.includes('{amount}')){
        value = formatWithDelimiters(cents, 2);
        return formatString.replace('{amount}', value);
    }else if(formatString.includes('{amount_no_decimals}')){
        value = formatWithDelimiters(cents, 0);
        return formatString.replace('{amount_no_decimals}', value);
    }else if(formatString.includes('{amount_with_comma_separator}')){
        value = formatWithDelimiters(cents, 2, '.', ',');
        return formatString.replace('{amount_with_comma_separator}', value);
    }else if(formatString.includes('{amount_no_decimals_with_comma_separator}')){
        value = formatWithDelimiters(cents, 0, '.', ',');
        return formatString.replace('{amount_no_decimals_with_comma_separator}', value);
    }else if(formatString.includes('{amount_no_decimals_with_space_separator}')){
        value = formatWithDelimiters(cents, 0, ' ');
        return formatString.replace('{amount_no_decimals_with_space_separator}', value);
    }else if(formatString.includes('{amount_with_apostrophe_separator}')){
        value = formatWithDelimiters(cents, 2, "'");
        return formatString.replace('{amount_with_apostrophe_separator}', value);
    }
}

function inex_pagination(current_page,page_count,adjacents){
    current_page = parseInt(current_page);
    page_count = parseInt(page_count);
    adjacents = parseInt(adjacents);

    var out = '<ul>';

    // previous
    if(current_page==1) {
        //out+='<li class="disabled"><a href="javascript:;"><span class="vdb-rb-icon vdb-rb-icon-detail_page_match_arrow_left_white"></span></a></li>';
    }else{
        out+=`<li>
                <a class="vdbrb_pagination_link" href="javascript:void(0);" data-current_page="${current_page-1}" >
                    <svg width="16" height="8" viewBox="0 0 16 8" fill="none" style="transform: rotate(90deg);" xmlns="http://www.w3.org/2000/svg">
                        <path d="M16 0.577355C16 0.429563 15.9392 0.28177 15.8178 0.169112C15.5749 -0.0563706 15.1808 -0.0563706 14.9379 0.169112L7.99996 6.60616L1.06214 0.169112C0.819116 -0.0563706 0.425158 -0.0563706 0.182134 0.169112C-0.0607115 0.394594 -0.0607115 0.760116 0.182134 0.985598L7.55995 7.83089C7.8028 8.05637 8.19693 8.05637 8.43978 7.83089L15.8176 0.985598C15.9392 0.87294 16 0.725147 16 0.577355Z" fill="#464646"></path>
                    </svg>
                </a>
            </li>`;
    }

    // first
    if(current_page>(adjacents+1)) {
        out+='<li><a class="vdbrb_pagination_link" href="javascript:void(0);" data-current_page="1">1</a></li>';
    }

    // interval
    if(current_page>(adjacents+2)) {
        out+='<li class="disabled"><a href="javascript:void(0);">...</a></li>';
    }

    // pages
    let pmin = (current_page>adjacents) ? (current_page-adjacents) : 1;
    let pmax = (current_page<(page_count-adjacents)) ? (current_page+adjacents) : page_count;
    for(let i=pmin; i<=pmax; i++) {
        if(i==current_page) {
            out+='<li class="active"><a href="javascript:void(0);">'+i+'</a></li>';
        }else{
            out+='<li><a class="vdbrb_pagination_link" href="javascript:void(0);" data-current_page="'+i+'">'+i+'</a></li>';
        }
    }

    // interval
    if(current_page<(page_count-adjacents-1)) {
        out+='<li class="disabled"><a href="javascript:void(0);">...</a></li>';
    }

    // last
    if(current_page<(page_count-adjacents)) {
        out+='<li><a class="vdbrb_pagination_link" data-current_page="'+page_count+'" href="javascript:void(0);">'+page_count+'</a></li>';
    }

    // next
    if(current_page<page_count) {
        out+=`
            <li>
                <a class="vdbrb_pagination_link" data-current_page="${current_page+1}" href="javascript:void(0);">
                    <svg width="16" height="8" viewBox="0 0 16 8" fill="none" style="transform: rotate(270deg);" xmlns="http://www.w3.org/2000/svg">
                        <path d="M16 0.577355C16 0.429563 15.9392 0.28177 15.8178 0.169112C15.5749 -0.0563706 15.1808 -0.0563706 14.9379 0.169112L7.99996 6.60616L1.06214 0.169112C0.819116 -0.0563706 0.425158 -0.0563706 0.182134 0.169112C-0.0607115 0.394594 -0.0607115 0.760116 0.182134 0.985598L7.55995 7.83089C7.8028 8.05637 8.19693 8.05637 8.43978 7.83089L15.8176 0.985598C15.9392 0.87294 16 0.725147 16 0.577355Z" fill="#464646"></path>
                    </svg>
                </a>
            </li>`;
    }else{
        //out+='<li class="disabled"><a href="javascript:;"><span class="vdb-rb-icon  vdb-rb-icon-detail_page_match_arrow_right_white"></span></a></li>';
    }

    out+= '</ul>';

    return out;
}

function number_format(nStr) {
    nStr += '';
    nStr = nStr.replace(',','');
    x = nStr.split('.');
    x1 = x[0];
    x2 = x.length > 1 ? '.' + x[1] : '';
    var rgx = /(\d+)(\d{3})/;
    while (rgx.test(x1)) {
        x1 = x1.replace(rgx, '$1' + ',' + '$2');
    }
    return x1 + x2;
}

function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

function array_unique(array){
    return array.filter(function(el, index, arr) {
        return index === arr.indexOf(el);
    });
}

function debounce(func, delay = 300) {
    let timeoutId;
    return function () {
        const context = this;
        const args = arguments;
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => {
            func.apply(context, args);
        }, delay);
    };
}

function getKeyByValue(object, value) {
    return Object.keys(object).find(key => object[key] === value);
}

$(document).on('keyup','.vdbrb_only_digit_with_two_decimal',function(e){
    var _this = $(this);

    var validNumber = new RegExp(/^\d*\.?\d*$/);
    if (validNumber.test((_this.val()))){
        _this.val(_this.val());
    }else{
        _this.val('');
    }

    //below code is for not allow double dot
    var event_keyCode = e.keyCode!=undefined?e.keyCode:'';
    if (((event_keyCode != 46 || (event_keyCode == 46 && $(this).val() == '')) ||
        $(this).val().indexOf('.') != -1) && (event_keyCode < 48 || event_keyCode > 57)) {
        e.preventDefault();
    }

    //below code allow only digit, dot and hifen
    var regx = /[^\d+(\.\d{1,2})?$-]/g;
    if(_this.val().match(regx)) {
        _this.val(_this.val().replace(regx, ''));
    }

    if(_this.val().includes(".")){
        var input_val_arr = _this.val().split('.');
        if(input_val_arr.length>2){
            //if we enter second dot, then remove last dot
            _this.val(_this.val().slice(0,-1));
            _this.val(parseFloat(_this.val()));

            //check NaN
            if(isNaN(_this.val())){
                _this.val('');
            }
        }

        //this code allow only 2 digit after dot
        if(input_val_arr[1].length>2){
            _this.val(input_val_arr[0]+'.'+input_val_arr[1].substring(0,2));
        }
    }
});

function generateProcessToken() {
    const characters = '0123456789abcdefghijklmnopqrstuvwxyz';
    let randomString = '';
  
    for (let i = 0; i < 10; i++) {
      const randomIndex = Math.floor(Math.random() * characters.length);
      randomString += characters[randomIndex];
    }
  
    return randomString;
}

function sleep(ms) {
    const start = new Date().getTime();
    while (new Date().getTime() - start < ms) {}
}